// Décision du controller native-analytics (app Hotwire Native, sans bandeau cookies). Pure, pour
// être testée sans DOM. Seul Rybbit dépend de la case « mesure d'usage » : Umami est exempté et
// se charge toujours. Un retrait du consentement ne coupe rien tant que la page n'est pas rechargée
// (Turbo ne retire jamais un <script> du <head>) : on décharge Rybbit, qui recharge la page s'il
// tournait déjà.
//
// - "load"   : consentement actif et page autorisée à Rybbit.
// - "unload" : plus de consentement, ou Rybbit coupé sur cette page (URL à jeton signé).
export function nativeAnalyticsAction({ granted, rybbitSrc }) {
  return granted && rybbitSrc ? "load" : "unload"
}
